module.exports = __webpack_public_path__ + "static/media/caret-circle-left.6001f038.svg";